var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleMapMobilecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 343 329",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 343,
    height: 329,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 329,
    fill: "#F0F0F0",
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#AEAEAE",
    strokeMiterlimit: 10,
    d: "M359.217 247.926l.142-.083a19.753 19.753 0 0119.722 0l.131.083a19.683 19.683 0 0019.722 0l.143-.083a19.753 19.753 0 0119.722 0l.143.083a19.733 19.733 0 019.855 17.084v.166a19.705 19.705 0 009.867 17.071l.131.083a19.72 19.72 0 019.867 17.084v.154a19.724 19.724 0 009.855 17.083l.143.083a19.73 19.73 0 019.867 17.072v.166a19.732 19.732 0 01-9.867 17.083l-.143.083a19.715 19.715 0 00-9.855 17.072v.166a19.724 19.724 0 01-9.867 17.083l-.131.071a19.68 19.68 0 01-19.722 0l-.143-.071a19.69 19.69 0 00-19.722 0l-.143.071a19.741 19.741 0 00-9.855 17.131v.167a19.695 19.695 0 01-9.867 17.071l-.131.083a19.741 19.741 0 01-19.722 0l-.19-.107a19.735 19.735 0 00-19.794 0v0a19.734 19.734 0 01-19.793 0h-.083a19.745 19.745 0 00-19.723 0l-.142.083a19.744 19.744 0 01-19.723 0l-.142-.083a19.744 19.744 0 00-19.722 0l-.131.083a19.744 19.744 0 01-19.722 0l-.143-.083a19.744 19.744 0 00-19.722 0l-.143.083a19.744 19.744 0 01-19.722 0l-.131-.083a19.695 19.695 0 01-9.867-17.071v-.143a19.724 19.724 0 019.867-17.083l.131-.071a19.68 19.68 0 0119.722 0l.143.071a19.69 19.69 0 0019.722 0l.143-.071a19.678 19.678 0 0119.722 0l.131.071a19.69 19.69 0 0019.722 0l.142-.071a19.749 19.749 0 009.867-17.083v-.238a19.74 19.74 0 019.856-17.083l.142-.072a19.692 19.692 0 0119.723 0l.13.072a19.713 19.713 0 0019.723 0l.142-.084a19.729 19.729 0 009.867-17.083v-.166a19.715 19.715 0 019.856-17.071l.142-.084a19.722 19.722 0 009.855-17.083v-.154a19.724 19.724 0 00-9.855-17.083l-.142-.084a19.704 19.704 0 01-9.856-17.071v-.166a19.738 19.738 0 019.856-17.048v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#AEAEAE",
    strokeMiterlimit: 10,
    d: "M329.497 93.168V93a19.705 19.705 0 00-9.855-17.071l-.155-.083a19.663 19.663 0 00-19.71 0l-.143.083a19.747 19.747 0 01-19.722 0l-.143-.083a19.663 19.663 0 00-19.71 0l-.155.083A19.715 19.715 0 00250.049 93v.167a19.733 19.733 0 01-9.855 17.047l-.143.083a19.702 19.702 0 00-9.831 17.107v.167a19.694 19.694 0 009.831 17.118l.143.084a19.663 19.663 0 0019.746-.084l.154-.083a19.723 19.723 0 0119.711 0l.142.083a19.749 19.749 0 019.867 17.084v.166a19.719 19.719 0 01-9.867 17.071l-.142.083a19.707 19.707 0 00-9.855 17.072v.166a19.73 19.73 0 01-9.856 17.083l-.154.083a19.722 19.722 0 01-19.711 0l-.142-.083a19.693 19.693 0 00-19.722 0l-.143.083a19.69 19.69 0 00-9.855 17.072v.166a19.706 19.706 0 01-9.867 17.107l-.155.083a19.658 19.658 0 01-19.71 0l-.143-.083a19.744 19.744 0 00-19.722 0l-.143.083a19.728 19.728 0 00-9.855 17.083v.167a19.714 19.714 0 009.855 17.071l.143.083a19.741 19.741 0 0019.722 0l.143-.083a19.716 19.716 0 0119.71 0l.155.083a19.716 19.716 0 0019.71 0l.143-.083a19.741 19.741 0 0119.722 0l.143.083a19.717 19.717 0 019.855 17.071v.167a19.731 19.731 0 009.867 17.083l.154.083a19.723 19.723 0 0019.711 0l.142-.083a19.684 19.684 0 0119.723 0l.142.083a19.723 19.723 0 0019.711 0l.154-.083a19.738 19.738 0 009.855-17.083v-.167a19.715 19.715 0 019.856-17.071l.142-.083a19.73 19.73 0 009.867-17.071v-.167a19.743 19.743 0 00-9.867-17.083l-.142-.083a19.692 19.692 0 01-9.856-17.071v-.167a19.695 19.695 0 00-9.855-17.071l-.154-.083a19.738 19.738 0 01-9.855-17.083v-.167a19.706 19.706 0 019.819-17.035v0a19.762 19.762 0 009.867-16.834v-.333a19.734 19.734 0 00-9.855-17.309v0a19.7 19.7 0 01-9.855-17.071v-.166a19.692 19.692 0 019.855-17.071l.154-.084a19.728 19.728 0 009.844-17.13v0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#AEAEAE",
    strokeMiterlimit: 10,
    d: "M458.47 110.216h.095a19.82 19.82 0 019.915 17.166v0a19.806 19.806 0 009.902 17.166v0a19.805 19.805 0 019.903 17.155 19.796 19.796 0 01-9.903 17.154 19.79 19.79 0 00-9.902 17.155v0a19.823 19.823 0 01-9.915 17.154v0a19.828 19.828 0 00-9.903 17.166v0a19.83 19.83 0 01-9.903 17.167v0a19.806 19.806 0 01-19.817 0 19.8 19.8 0 00-19.817 0v0a19.79 19.79 0 01-19.806 0v0a19.797 19.797 0 00-19.817 0v0a19.81 19.81 0 01-29.72-17.167v0a19.833 19.833 0 00-9.903-17.166v0a19.82 19.82 0 01-9.914-17.154v0a19.802 19.802 0 019.581-16.846v0a19.817 19.817 0 009.903-17.154v0a19.835 19.835 0 00-9.855-17.321v0a19.812 19.812 0 01-9.915-17.166v0a19.812 19.812 0 019.915-17.167v0a19.786 19.786 0 0119.805 0v0a19.804 19.804 0 0019.818 0 19.807 19.807 0 0119.817 0 19.779 19.779 0 0019.805 0v0a19.813 19.813 0 009.915-17.154 19.805 19.805 0 019.903-17.166v0a19.783 19.783 0 0119.805 0v0a19.806 19.806 0 019.915 17.083v.214a19.835 19.835 0 0010.093 16.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    stroke: "#AEAEAE",
    strokeMiterlimit: 10,
    d: "M339.423-164.947a19.873 19.873 0 019.939 17.19 19.854 19.854 0 009.926 17.202v0a19.853 19.853 0 019.927 17.274v0a19.867 19.867 0 002.666 9.931 19.868 19.868 0 007.272 7.27v0a19.873 19.873 0 019.927 17.203v0a19.87 19.87 0 01-9.927 17.19v0a19.87 19.87 0 00-9.938 17.202v0a19.872 19.872 0 009.938 17.202v0a19.873 19.873 0 019.927 17.202 19.865 19.865 0 009.95 17.166v0a19.866 19.866 0 019.938 17.202v0a19.848 19.848 0 009.927 17.19 19.865 19.865 0 019.926 17.202v0a19.854 19.854 0 01-9.926 17.202 19.864 19.864 0 00-9.927 17.202v0a19.854 19.854 0 01-9.938 17.202v0a19.817 19.817 0 01-19.853 0v0a19.892 19.892 0 00-19.865 0v0a19.839 19.839 0 01-19.865 0v0a19.857 19.857 0 01-9.926-17.202 19.868 19.868 0 00-9.927-17.202v0a19.88 19.88 0 01-9.926-17.202v0a19.87 19.87 0 019.938-17.202 19.86 19.86 0 009.927-17.19v0a19.853 19.853 0 019.926-17.202v0a19.88 19.88 0 009.938-17.202 19.858 19.858 0 00-9.938-17.202v0a19.876 19.876 0 00-19.853 0 19.89 19.89 0 01-19.865 0v0a19.86 19.86 0 01-9.926-17.202v0a19.88 19.88 0 00-9.939-17.202v0a19.839 19.839 0 01-9.926-17.19v0a19.853 19.853 0 019.926-17.202v0a19.883 19.883 0 009.903-17.166v0a19.845 19.845 0 019.927-17.202v0a19.858 19.858 0 009.926-17.274v0a19.872 19.872 0 019.938-17.202v0a19.883 19.883 0 0119.853.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M169.758 270.443a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M209.487 270.443a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M150.511 231.307a.594.594 0 100-1.188.594.594 0 000 1.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M229.352 236.063a4.756 4.756 0 100-9.511 4.756 4.756 0 000 9.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M249.205 270.443a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M288.923 270.443a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M328.653 270.443a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M269.082 304.585a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M308.8 304.585a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M288.923 201.919a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M329.842 207.864c5.252 0 9.51-4.258 9.51-9.511a9.51 9.51 0 00-9.51-9.51 9.51 9.51 0 100 19.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M269.082 236.063a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M308.8 236.063a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M349.706 242.006a9.51 9.51 0 100-19.02 9.51 9.51 0 000 19.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M249.205 132.433a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M288.923 132.433a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M329.842 138.377a9.51 9.51 0 009.51-9.51 9.51 9.51 0 10-9.51 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M308.8 166.577a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M349.706 172.52c5.253 0 9.511-4.258 9.511-9.51 0-5.253-4.258-9.51-9.511-9.51a9.51 9.51 0 000 19.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M329.14 70.47a9.51 9.51 0 10-9.51-9.51 9.51 9.51 0 009.51 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M269.082 98.066a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M308.8 98.066a4.755 4.755 0 100-9.51 4.755 4.755 0 000 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M350.039 102.71a9.51 9.51 0 100-19.02 9.51 9.51 0 000 19.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B85",
    d: "M349.005 35.78a9.51 9.51 0 009.51-9.51 9.51 9.51 0 10-19.02 0 9.51 9.51 0 009.51 9.51z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M236.346 270.932l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M237.187 254.959l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M253.158 254.12l5.846 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M217.327 236.457l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M218.167 220.485l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M234.139 219.645l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M197.117 270.932l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M197.957 254.959l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M213.929 254.12l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M159.075 270.932l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M159.916 254.959l20.174 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M175.887 254.12l5.846 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M276.767 270.932l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M277.607 254.959l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M293.578 254.12l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M260.124 306.596l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M260.964 290.624l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M276.936 289.784l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M257.745 236.457l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M258.586 220.485l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M274.558 219.645l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M238.725 134.22l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M239.565 118.248l20.175 20.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M255.537 117.407l5.845 5.846"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M258.935 98.555l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M259.775 82.583l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M275.747 81.743l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M315.998 270.932l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M316.838 254.959l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M332.809 254.12l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M299.354 306.596l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M300.195 290.624l20.174 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M316.166 289.784l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M296.976 236.457l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M297.816 220.484l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M313.788 219.644l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M277.955 134.22l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M278.796 118.248l20.175 20.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M294.768 117.408l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M298.165 98.555l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M299.005 82.583l20.175 20.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M314.977 81.743l5.845 5.846"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M277.956 203.17l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M278.796 187.198l20.175 20.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M294.768 186.358l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M298.165 167.507l5.884 5.884"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M299.006 151.535l20.175 20.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M314.978 150.695l5.845 5.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M336.963 23.06v8.322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M342.907 15.927v21.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M338.151 89.632v8.321"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M317.942 57.535v8.321"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M323.886 50.402v21.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M329.83 46.835v28.532"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M335.774 50.402v21.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M341.718 57.535V65.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M338.151 228.721v8.322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M317.942 195.436v8.322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M323.886 188.303v21.011"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M329.83 184.737v28.531"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M335.774 188.303v21.011"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M341.718 195.436v8.267"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M338.151 159.771v8.322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M317.942 125.296v8.322"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M323.886 118.164v21.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M329.83 114.597v28.531"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M335.774 118.164v21.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C2664",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M341.718 125.296v8.267"
  }))));
}

export default __webpack_public_path__ + "bubble-map-mobile.colors.4a6569f3.svg";
export { SvgBubbleMapMobilecolors as ReactComponent };